// index.js
import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import ScrollToTop from './ScrollToTop';
import About from './pages/about';
import SBDC from './pages/sbdc';
import WT from './pages/wt';
import WDT from './pages/wdt';
import CPD_DMS from './pages/cpd_dms';
import FOTG from './pages/fotg';
import SIPPS from './pages/sipps';
import Home from './pages/home';
import PasswordComponent from './PasswordComponent';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

function ResumeRedirect() {
  React.useEffect(() => {
    window.location.href = "/img/about/AmberSChenResume.pdf";
  }, []);
  return null;
}

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState();

  const handlePasswordSubmit = (enteredPassword) => {

    const correctPassword = '5555';

    if (enteredPassword === correctPassword) {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password. Please try again.');
    }
  };

  return (
    <React.StrictMode>
      <BrowserRouter>
          <ScrollToTop>
            <Routes>
              <Route path="/" element={<App />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="sbdc" element={<SBDC />} />
                <Route path="wt" element={<WT />} />
                <Route path="fotg" element={<FOTG />} />
                <Route path="wdt" element={<WDT />} />
                <Route path="cpd_dms" element={<CPD_DMS />} />
                <Route path="sipps" element={<SIPPS />} />
                <Route path="resume" element={<ResumeRedirect />} />
              </Route>
            </Routes>
          </ScrollToTop>
      </BrowserRouter>
    </React.StrictMode>
  );
};

root.render(<Index />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
